import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';
import NoResultsLearningCollectionIcon from '../../Cutesies/NoResultsLearningCollectionIcon';
import LearningCollectionsStore from '../Store';

interface Props {
  store: LearningCollectionsStore;
}

const handleSelectReset = (store: LearningCollectionsStore) => {
  store.resetSearchParameters();
};

const LearningCollectionsNoResults: React.FC<Props> = ({ store }) => {
  return (
    <div className={clsx('py-12 px-1 text-center md:px-0')}>
      <div>
        <div className="inline-block w-full md:w-2/5">
          <NoResultsLearningCollectionIcon />
        </div>
        <p className="mt-9 text-lg font-bold text-gray-500">
          <T kind="No Learning Collections found" />
        </p>
        <p className="text-base text-gray-500 max-w-full inline-block text-center w-3/5 lg:w-3/5 break-words">
          <T kind="Please modify your search" />
        </p>
      </div>
      <div className="mt-8">
        <button
          className={clsx(
            'inline-block cursor-pointer whitespace-nowrap text-center',
            'rounded-md border-solid border-1 border-teal-600 py-2 px-4',
            'font-medium tracking-wide hover:bg-teal-500',
            'bg-white  text-sm text-teal-600',
          )}
          onClick={() => handleSelectReset(store)}
        >
          <T kind="Reset all filters" />
        </button>
      </div>
    </div>
  );
};

export default observer(LearningCollectionsNoResults);
